/**
 * !!! AUTOGENERATED, DO NOT MODIFY !!!
 *
 * This file is generated by dashboard/script/remote_lookup/generate_remote_lookup_schemas.rb
 * Because the generation script depends on rails, generation is run manually and the file is checked in.
 * Please do not edit manually.
 *
 * To regenerate, run:
 *   yarn remote-lookup:update-generated-schemas
 *
 * @owner @Appboy/messaging-experience
 */

import { z } from "zod";

// Our zod-to-typescript generation tooling demands an export that matches the module name.
export const cohortRemoteLookupSchema = z.any();

export const cohortRemoteLookupIdSchema = z.string();

export const cohortRemoteLookupItemSchema = z.object({
  partner_token: z.enum([
    "a",
    "ab",
    "af",
    "ap",
    "b",
    "c",
    "cf",
    "db",
    "h",
    "ht",
    "k",
    "m",
    "s",
    "sa",
    "sh",
    "t",
    "tr",
  ]),
  cohort_id: z.string(),
  name: z.string(),
});

export const cohortRemoteLookupFiltersSchema = z.object({
  partner_token: z
    .enum(["a", "ab", "af", "ap", "b", "c", "cf", "db", "h", "ht", "k", "m", "s", "sa", "sh", "t", "tr"])
    .nullable()
    .optional(),
});

export const cohortRemoteLookupValidators = {
  id: cohortRemoteLookupIdSchema,
  item: cohortRemoteLookupItemSchema,
  filters: cohortRemoteLookupFiltersSchema,
};

/* rails_test_output_hash: 6c7a881127e1265cd3b0fb3037ec9f67 */
